import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";
import axios from "axios";

const Bildwechsel = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  // falls kein Wert vorhanden, dann 0 setzen
  if (value.value === "") {
    value.value = "0";
  }

  // Index als Wert aus globalVars
  let idx = Math.abs(parseInt(value.value));

  //========================================================================
  // Simulation
  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    idx = Math.abs(parseInt(simValue));
  }

  //========================================================================
  // Bildnamen aus übergebenem Array ermitteln
  let imgName = null;

  if (isFinite(idx)) {
    try {
      if (idx > (props.element.images.length - 1)) {
        idx = 0;
      }
      imgName = props.element.images[idx];
    } catch (error) {
      imgName = null;
    }
  }

  //========================================================================
  // Zustandsvariablen für dynamisches Laden
  const [imageSrc, setImageSrc] = useState(null);
  const [error, setError] = useState(false);

  //========================================================================
  // Bild laden, sobald sich der Bildname ändert
  useEffect(() => {
    let isCancelled = false;
    let objectUrl = null;

    if (!imgName) {
      setImageSrc(null);
      setError(false);
      return;
    }

    const fetchImage = async () => {
      try {
        const url =
          window.location.port === "3000"
            ? `http://${window.location.hostname}:${globalVars.httpPort}/project/images/${imgName}`
            : `/project/images/${imgName}`;

        const response = await axios.get(url, {
          responseType: "blob",
        });

        if (!isCancelled) {
          objectUrl = URL.createObjectURL(response.data);
          setImageSrc(objectUrl);
          setError(false);
        }
      } catch (err) {
        if (!isCancelled) {
          setError(true);
        }
      }
    };

    fetchImage();

    return () => {
      isCancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [imgName, globalVars.updateElementsTrigger]);

  //========================================================================
  // Grafische Darstellung
  if (error) {
    return (
      <p>
        {language.displayText(["Bild konnte nicht geladen werden", "", ""])}
      </p>
    );
  }

  return (
    <img
      style={{
        ...props.style,
        visibility: props.props.visibility,
      }}
      title={
        props.element.tooltip
          ? language.displayText(props.element.tooltip) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "")
          : language.displayText(value.name) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "") +
            (globalVars.cyclicUpdate || globalVars.editor
              ? "\n" + ("Variable: " + props.props.variable)
              : "")
      }
      src={imageSrc}
    />
  );
});

export default Bildwechsel;
